import { IView } from "../Core/View";
import { ViewFactory } from "../Core/Factories/ViewFactory";
import { GalleryIndexView } from "./Gallery/GalleryIndexView";

ViewFactory.setRegistry({
    'GalleryIndexView': GalleryIndexView,
});


// WEBPACK FOOTER //
// ./www/js/Pages/Media.ts